import { render, staticRenderFns } from "./req-pay-review.vue?vue&type=template&id=6a9a0532&scoped=true"
import script from "./req-pay-review.vue?vue&type=script&lang=js"
export * from "./req-pay-review.vue?vue&type=script&lang=js"
import style0 from "./req-pay-review.vue?vue&type=style&index=0&id=6a9a0532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a0532",
  null
  
)

export default component.exports